import { GlobalAdminItem} from "./GlobalAdminItem";

export default GlobalAdminItem;
